import { render, staticRenderFns } from "./GoogleRecaptcha.vue?vue&type=template&id=8ad7c84a&scoped=true"
import script from "./GoogleRecaptcha.vue?vue&type=script&lang=js"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=js"
import style0 from "./GoogleRecaptcha.vue?vue&type=style&index=0&id=8ad7c84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad7c84a",
  null
  
)

export default component.exports